import { StorageMaintenanceState } from "@/models/storageMaintenance/interfaces/storageMaintenance";

const checkTimeStampExpiration = timeStamp => {
  const now = Date.now();
  const expirationTime = parseInt(process.env.VUE_APP_USER_SELECTIONS_EXPIRATION_TIME || "");
  return now > timeStamp + expirationTime;
};

export const getUserSelectionsStorage = (state: StorageMaintenanceState) => {
  return state.userSelectionsStorage;
};

export const isUserSelectionExpired = (state: StorageMaintenanceState) => {
  return checkTimeStampExpiration(state.userSelectionsStorage);
};

export const isIwSettingsTimeStampExpired = (state: StorageMaintenanceState) => {
  return checkTimeStampExpiration(state.iwSettingsTimeStamp);
};

export const isVenueTimeStampExpired = (state: StorageMaintenanceState) => {
  return checkTimeStampExpiration(state.venueTimeStamp);
};

export const isVendorTimeStampExpired = (state: StorageMaintenanceState) => {
  return checkTimeStampExpiration(state.vendorTimeStamp);
};

export const isItemsTimeStampExpired = (state: StorageMaintenanceState) => {
  return checkTimeStampExpiration(state.itemsTimeStamp);
};
